module.exports = __webpack_public_path__ + "img/quatrieme-couverture-le-murmure-des-attentes-550.31623bb4.png";